<template>
  <div>
    <van-field v-model="issue.inputValue" placeholder="请输入地点、街道等位置信息" @focus="getPoiFlag = true" />
    <ul v-if="poiList.length" class="pl-2 pois-group border border-solid border-gray-300 border-t-0">
      <li v-for="(poi, index) in poiList" @click="onClickSelectValue(poi)" :key="index">
        <van-icon name="location-o" />
        {{ poi.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TextMap',
  props: {
    issue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      inputValue: '',
      poiList: [],
      getPoiFlag: false
    }
  },
  computed: {
    disallowInput() {
      return this.issue.disallowInput
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.issue.value) {
    //     this.inputValue = this.issue.value.split('|')[0]
    //   }
    // })
  },
  methods: {
    onClickSelectValue(val) {
      this.issue.inputValue = val.name
      this.getPoiFlag = false
      this.poiList = []
      this.$emit('change', val)
      this.issue.changeValue(val)
    }
  },
  watch: {
    'issue.inputValue'(val) {
      if (!this.getPoiFlag) return
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.issue.getPoiList(val).then(list => {
          this.poiList = list
        })
        this.timer = null
      }, 300)
    }
  }
}
</script>
<style lang="scss" scoped>
.pois-group {
  box-sizing: border-box;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  @apply rounded;
  li {
    border-bottom: 1px solid #eaeaea;
    padding-right: 20px;
    font-size: 14px;
    @apply py-2 text-gray-500;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
